<template>
  <div class="foreign-info-collection-page">
    <div class="page-content">
      <foreign-info-collection
        :contract-data="contractData"
        @submit-success="onSubmitSuccess"
        @cancel="onCancel"
      />
    </div>
  </div>
</template>

<script>
import { NavBar } from 'vant';
import 'vant/lib/nav-bar/style';
import Toast from 'vant/lib/toast';
import ForeignInfoCollection from './components/ForeignInfoCollection';
import billApi from '@/api/bill';

export default {
  name: 'ForeignInfoCollectionPage',
  components: {
    [NavBar.name]: NavBar,
    ForeignInfoCollection,
  },
  data() {
    return {
      contractData: {},
      loading: false,
    };
  },
  created() {
    this.queryContractData();
  },
  methods: {
    async queryContractData() {
      this.loading = true;
      try {
        const response = await billApi.getSignAndFace();
        if (response.data && response.code === 0) {
          this.contractData = response.data || {};
          console.log('Contract data:', this.contractData);
        } else {
          Toast.fail(response.data?.message || '获取签约信息失败');
          this.$router.back();
        }
      } catch (error) {
        console.error('Query contract data error:', error);
        Toast.fail('获取签约信息失败');
        this.$router.back();
      } finally {
        this.loading = false;
      }
    },

    onSubmitSuccess() {
      // 提交成功后跳回首页
      this.$router.back();
    },

    onCancel() {
      // 取消时返回确认账单页
      this.$router.back();
    },

    onBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme';

.foreign-info-collection-page {
  min-height: 100vh;
  background: #f7f8fa;

  .page-content {
    padding-top: 0;
  }
}
</style>
